export default __webpack_public_path__ + "static/media/1104.a8c5f548.png";